import React from "react";
import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";

const ServiceLast = () => {
  return (
    <Box bg="#F7F1E6" minH="50vh" display="flex" alignItems="center" justifyContent="center" px={{ base: 4, md: 16 }}>
      <VStack spacing={6} textAlign="center" maxW="800px" mx="auto">
        {/* Heading */}
        <Heading fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold" className="fade-in-up">
          Ready To Grow Your Business?
          <br />
          Let’s Get Digital!
        </Heading>

        {/* Description */}
        <Text fontSize={{ base: "md", md: "lg" }} color="gray.700" className="fade-in-up">
          Want to take your brand to the next level? Doggle India is your go-to partner for
          smart, innovative, and effective digital marketing solutions. With Marwadi insights,
          Indian jugaad, and cutting-edge strategies, we ensure your business thrives in the
          digital world.
        </Text>

        {/* Contact Us Button */}
        <Button
          bg="#005770"
          color="white"
          px={6}
          py={4}
          fontSize={{ base: "sm", md: "md" }}
          borderRadius="md"
          _hover={{ bg: "#00465F" }}
        >
          Contact Us →
        </Button>
      </VStack>
    </Box>
  );
};

export default ServiceLast;
